<template>
  <div class="page">

    <accordion :multiple="true" :activeIndex="[0, 1]" >
      <accordion-tab>
        <template #header>
          <span>Fatture Scadute</span>
        </template>

        <div v-if="data_.fattureScadute.length > 0">
          <div v-for="(item, index) in data_.fattureScadute" :key="index">
            <div v-if="item">
              
              <span>{{ item.cliente }} -</span>&nbsp;
              <span>({{ currencyFormatter.format( (item.totale !== null)? item.totale: 0 ) }})</span>

              <data-table :value="item.fatture" v-model:selection="data_.selectedInvoices[index]" dataKey="numero" responsiveLayout="scroll" >
                <column selectionMode="multiple" headerStyle="width: 3em"></column>
                <column field="numero" header="Numero"></column>
                <column field="data_emissione" header="Data Emissione">
                  <template #body="{data}">
                    {{ (data.data_emissione !== null)? moment(data.data_emissione).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="data_scadenza" header="Data Scadenza">
                  <template #body="{data}">
                    {{ (data.data_scadenza !== null)? moment(data.data_scadenza).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="saldo" header="Importo Dovuto">
                  <template #body="{data}">
                    {{currencyFormatter.format( (data.saldo !== null)? data.saldo: 0 )}}
                  </template>
                </column>
              </data-table>

              <div v-if="data_.selectedInvoices[index].length > 0" class="p-d-flex p-p-3 card">
                <prime-button label="Aggiungi" icon="pi pi-plus-circle" class="mb-auto" @click="onAddFatturaToSollecitoButton(index)" />
              </div>

            </div>
          </div>
        </div>
      </accordion-tab>

      <accordion-tab>
        <template #header>
          <span>Solleciti</span>
        </template>

        <div v-if="data_.fattureInSollecito.length > 0">
          <div v-for="(item, index) in data_.fattureInSollecito" :key="index">
            <div v-if="item">

              <span>{{ item.cliente }} -</span>&nbsp;
              <span>({{ currencyFormatter.format( (item.totale !== null)? item.totale: 0 ) }})</span>

              <data-table :value="item.fatture" v-model:selection="data_.selectedInSollecito[index]" dataKey="numero" responsiveLayout="scroll" >
                <column selectionMode="multiple" headerStyle="width: 3em"></column>
                <column field="numero" header="Numero"></column>
                <column field="data_emissione" header="Data Emissione">
                  <template #body="{data}">
                    {{ (data.data_emissione !== null)? moment(data.data_emissione).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="data_scadenza" header="Data Scadenza">
                  <template #body="{data}">
                    {{ (data.data_scadenza !== null)? moment(data.data_scadenza).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="saldo" header="Importo Dovuto">
                  <template #body="{data}">
                    {{currencyFormatter.format( (data.saldo !== null)? data.saldo: 0 )}}
                  </template>
                </column>
                <column field="data_sollecito" header="Data Sollecito">
                  <template #body="{data}">
                    {{ (data.data_sollecito !== null)? moment(data.data_sollecito).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
              </data-table>

              <div class="p-d-flex p-p-3 card">
                <prime-button label="PDF" icon="pi pi-file-pdf" class="mb-auto" @click="onGetPdfButton(index)" />
              </div>

            </div>
          </div>
        </div>

      </accordion-tab>

    </accordion>

  </div>
</template>

<script>
import moment from 'moment'
import slugify from 'slugify'

import Service from '@/services/ask-management/solleciti-fatture-clienti-service.js'

import PrimeButton from 'primevue/button'

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  
  components: {
    PrimeButton,
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      page:{
        name: 'clienti-sollecito',
      },

      data_:{
        selectedInvoices: [],
        selectedInSollecito: [],

        clientiIds: this.data,
        fattureScadute: [],
        fattureInSollecito: [],
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    this.getAllFattureScadute()
    this.getAllFattureInSollecito()
  },

  methods:{

    onCancelButton(){
      this._reset()
      
      this.$eventBus.emit('dialog-return-cancel-button', {})
    },

    /////

    onAddFatturaToSollecitoButton(index){
      this.service.insertFattureToSolleciti({
        'fattura_vendita.numeri': this.data_.selectedInvoices[index].map((el) => el.numero)
      }).then((res) => {
        this.data_.selectedInvoices[index] = []

        if(res.result){
          this.getAllFattureScadute()
          this.getAllFattureInSollecito()
        }
      })
    },

    onGetPdfButton(index){
      this.service.downloadFileSollecitiZip({
        'fattura_vendita.numeri': this.data_.selectedInSollecito[index].map((el) => el.numero)
      })
    },

    ////

    _reset(){
      this.data_.selectedInvoices = []
      this.data_.selectedInSollecito = []

      this.data_.clientiIds = []
      this.data_.fattureScadute = []
      this.data_.fattureInSollecito = []
    },

    getAllFattureScadute(){
      this.service.getAllFattureScadute({
        'cliente.ids': this.data_.clientiIds
      }).then((res) => {
        this.data_.fattureScadute = Object.entries(res.item).map((el) => {
          return {
            slug: slugify(el[0], {lower: true}),
            cliente: el[0],
            totale: el[1].totale,
            fatture: el[1].fatture
          }
        })

        this.data_.fattureScadute.forEach((_, i) => {
          this.data_.selectedInvoices[i] = []
        })
        
      })
    },

    getAllFattureInSollecito(){
      this.service.getAllFattureInSollecito({
        'cliente.ids': this.data_.clientiIds
      }).then((res) => {
        this.data_.fattureInSollecito = Object.entries(res.item).map((el) => {
          return {
            slug: slugify(el[0], {lower: true}),
            cliente: el[0],
            totale: el[1].totale,
            fatture: el[1].fatture
          }
        })
      })
    },
  },

}
</script>

<style scoped>

</style>
